import { render, staticRenderFns } from "./BrandBanner.vue?vue&type=template&id=b6562b96&scoped=true"
import script from "./BrandBanner.vue?vue&type=script&lang=js"
export * from "./BrandBanner.vue?vue&type=script&lang=js"
import style0 from "./BrandBanner.vue?vue&type=style&index=0&id=b6562b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6562b96",
  null
  
)

export default component.exports